module.exports = ["Singapore Citizen","Permanent Resident","Employee Pass","Work Permit","S Pass","Dependent Pass"]


//////////////////
// WEBPACK FOOTER
// ./static/userProfile/idType.json
// module id = ./static/userProfile/idType.json
// module chunks = 0 7 10 12 14